import { FC } from 'react';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import { CheckSpot } from 'assets/customIcon/CheckSpot';
import { ModalLitContent } from './styled';

interface PreviewModalProps {
  visible: boolean;
  orderType: string;
  onSubmit: () => void;
  onCloseModal: () => void;
}

const getOrderType = (type: string) => {
  const textLIT = 'Limit If Touched';
  return ['Auto Buy', 'AutoBuy'].includes(type) ? textLIT : type;
};

const SmartOrderPlacedModal: FC<PreviewModalProps> = ({
  visible,
  orderType,
  onSubmit,
  onCloseModal,
}) => (
  <Modal
    visible={visible}
    width="420px"
    onCancel={onCloseModal}
    centered
    closable={false}
    type="transparent"
  >
    <ModalLitContent>
      <div className="container">
        <div className="info">
          <CheckSpot />
          <Text size="18px" family="bold" align="center">
            {getOrderType(orderType)} Berhasil Dipasang
          </Text>
        </div>
      </div>

      <Button
        onClick={onSubmit}
        type="primary"
        radius="4px"
        block
        height="44px"
      >
        <Text align="inherit" color="inherit" family="bold" size="14px">
          Done
        </Text>
      </Button>
    </ModalLitContent>
  </Modal>
);

export default SmartOrderPlacedModal;
